/**
 * EVENT_TYPES: The canonical "Citizen Types" for the Master Plan ecosystem.
 */
export const EVENT_TYPES = {
    PERFORMANCE: 'PERFORMANCE',
    MOBILITY: 'MOBILITY',
    RECOVERY: 'RECOVERY',
    NUTRITION: 'NUTRITION',
    SUPPLEMENTATION: 'SUPPLEMENTATION',
    TASK: 'TASK'
} as const;

export type EventType = keyof typeof EVENT_TYPES;

export const EVENT_THEMES: Record<string, string> = {
    [EVENT_TYPES.PERFORMANCE]: '#f29b11', // Orange
    [EVENT_TYPES.MOBILITY]: '#ef4444',    // Red
    [EVENT_TYPES.RECOVERY]: '#3b82f6',    // Blue
    [EVENT_TYPES.NUTRITION]: '#2ecc71',   // Green
    [EVENT_TYPES.SUPPLEMENTATION]: '#a855f7', // Purple
    [EVENT_TYPES.TASK]: '#64748b'         // Slate
};
